import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export const DryerSettingsText = (props: { text: string | null | undefined }) => {

    return <>
        <CopyToClipboard text={props.text ?? ''}>
            <div
                style={{
                    width: "100%",
                    minHeight: "504px",
                    whiteSpace: 'preserve',
                    cursor: 'copy',
                    textAlign: "center", resize: "none",
                    border: 0
                }}
            >
                <span>{props.text ?? ''}</span>
            </div>
        </CopyToClipboard>
    </>
}
